import React from 'react';
import biologicalRoutes from './biological/BiologicalRoutes';
import corpPracticesRoutes from './corp-practices/PracticesRoutes';
import deRoutes from './dentalenhancements/DERoutes';
import devicesRoutes from './devices/DevicesRoutes';
import groupsRoutes from './groups/groupsRoutes'
import medicationsRoutes from './medications/MedicationsRoutes';
import practiceRoutes from './practice/PracticeRoutes';
import trainingRoutes from './training/TrainingRoutes';
import wasteManagementRoutes from './wastemanagement/WasteManagementRoutes';
import waterlineManagementRoutes from './waterline-management/WaterlineManagementRoutes';
import demoRoutes from './demo/DemoRoutes';
import dashboardRoutes from './dashboard/DashboardRoutes';

import Contact from '../../views/common/Contact';
import Faq from '../../views/common/Faq';
import Guides from '../../views/common/Guides';
import PrivacyPolicy from '../../views/common/PrivacyPolicy';
import SDS from '../../views/practice/sds/SDS';
import Terms from '../../views/common/Terms';
import PaymentRedirect from '../../components/PaymentRedirect';
import CorporateRouteGuard from '../../components/CorporateRouteGuard';

// Helper function to wrap routes with access control
const wrapWithCorporateGuard = (routes) => {
  return routes.map(route => ({
    ...route,
    element: <CorporateRouteGuard>{route.element}</CorporateRouteGuard>
  }));
};

const miscRoutes = [
  {
    path: '/corp/contact',
    element: <Contact />
  },
  {
    path: '/corp/faq',
    element: <Faq />
  },
  {
    path: '/corp/terms',
    element: <Terms />
  },
  {
    path: '/corp/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/corp/guides',
    element: <Guides />
  },
  {
    path: '/corp/sds',
    element: <SDS />
  },
  {
    path: '/corp/payment',
    element: <PaymentRedirect fallbackPath="/corp/dashboard" />
  }
];

const corporateRoutes = [
  ...wrapWithCorporateGuard(miscRoutes),
  ...wrapWithCorporateGuard(biologicalRoutes),
  ...wrapWithCorporateGuard(corpPracticesRoutes),
  ...wrapWithCorporateGuard(deRoutes),
  ...wrapWithCorporateGuard(devicesRoutes),
  ...wrapWithCorporateGuard(groupsRoutes),
  ...wrapWithCorporateGuard(medicationsRoutes),
  ...wrapWithCorporateGuard(practiceRoutes),
  ...wrapWithCorporateGuard(trainingRoutes),
  ...wrapWithCorporateGuard(wasteManagementRoutes),
  ...wrapWithCorporateGuard(waterlineManagementRoutes),
  ...wrapWithCorporateGuard(demoRoutes),
  ...wrapWithCorporateGuard(dashboardRoutes)
];

export default corporateRoutes;
